import useGlobalContext from "hooks/globalData";
import { useQuery } from "react-query";
import {
  Attribute,
  ListRequestOfBaseFilter,
  ListResponseOfState,
} from "services/KnowfullyAdminClient";
import { AttributeMetaValues } from "types/common-types";

export function StateColumnView({ value }: { value: Attribute }) {
  const { stateService } = useGlobalContext();

  const storedId = value.attributeMetaValues?.find(
    (m) => m.name === AttributeMetaValues.StateId,
  )?.value;

  const { data } = useQuery<ListResponseOfState>(
    ["stateService.getStates"],
    () =>
      stateService.getStates(
        ListRequestOfBaseFilter.fromJS({ sortField: "stateName" }),
      ),
  );

  if (!storedId) return null;

  const state = data?.data?.find(
    (d) => String(d.id ?? "").toLowerCase() === String(storedId).toLowerCase(),
  );
  const label = state
    ? state.name
      ? `${state.stateName} (${state.name})`
      : state.stateName ?? ""
    : "";
  return <>{label}</>;
}
